import { useContext } from 'react'
import { useTangerineApi } from 'domains/tangerine/hooks'
import { PatientContext } from 'ui/contexts'

const createPostReportLLMRequest = (
  patientId,
  startTime,
  endTime,
  regenerate,
) => ({
  patient_id: patientId,
  start_date: startTime,
  end_date: endTime,
  regenerate,
})

const createPatchReportLLMRequest = (
  patientId,
  reportId,
  editedSummaries,
  reviewerComments,
  reviewerClassification,
) => ({
  patient_id: patientId,
  llm_report_data_id: reportId,
  edited_summaries: editedSummaries,
  reviewer_comments: reviewerComments,
  reviewer_classification: reviewerClassification,
  approved: true,
})

const useReportLLM = ({ options, method = 'POST', endpointSuffix = '' }) => {
  const patientContext = useContext(PatientContext) || {}

  let params = {}
  switch (method) {
    case 'GET':
      params = createPostReportLLMRequest(
        patientContext.id,
        options?.start,
        options?.end,
        options?.regenerate,
      )
      break
    case 'POST':
      params = createPostReportLLMRequest(
        patientContext.id,
        options?.start,
        options?.end,
        options?.regenerate,
      )
      break
    case 'PATCH':
      params = createPatchReportLLMRequest(
        patientContext.id,
        options?.reportId,
        options?.editedSummaries,
        options?.reviewerComments,
        options?.reviewerClassification,
      )
      break
    default:
      break
  }

  const {
    data = [],
    errors,
    loading,
  } = useTangerineApi({
    path: '/api/v3/llm_report_data',
    endpointSuffix,
    method,
    params,
    skip: !options,
  })

  return {
    data,
    isLoading: loading,
    hasError: !!(errors && errors.length),
  }
}

export default useReportLLM
